<template>
  <v-app class="grey lighten-3" v-if="isLoggedIn">
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <span class="headline">Search responses with keyword</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <!-- <v-flex xs12 sm6 md6>
                    <v-select
                      v-model="searchItem.project_id"
                      :rules="projects"
                      :items="indexData.allProjects"
                      item-text="name"
                      item-value="id"
                      box
                      label="Select a project"
                    ></v-select>
                  </v-flex> -->
                  <v-flex xs12 sm8>
                    <v-text-field
                      v-model="searchItem.keyword"
                      :rules="keyword"
                      box
                      label="Searching keyword"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-btn
                      class="button"
                      flat
                      @click="submit"
                      >Search</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              
            </v-card-actions>
          </v-card>
          <v-spacer></v-spacer>
          <v-card class="mt-2">
            <v-card-title class="project">
              <span class="headline">Response Data</span>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="getColumns()"
                :items="indexData.response"
                :search="search"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">{{ props.item.id }}</td>
                  <td class="text-xs-center">{{ props.item.project_id }}</td>
                  <td class="text-xs-center">
                    {{ props.item.dasher_id }}
                  </td>
                  <td v-for="(coldata, index) in indexData.projects_variables" :key="index">
                    {{ getDataForView(props.item, coldata) }}
                  </td>
                  <!-- <td class="justify-center layout px-0">
                    <v-icon small class="mr-2" @click="editItem(props.item)">
                      edit
                    </v-icon> -->
                    <!-- <v-icon small @click="deleteItem(props.item)">
                        delete
                      </v-icon> -->
                  <!-- </td> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
  
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router";
// import Signin from "@/views/auth/Signin";

export default {
 

  data: () => ({
    apiUrl: "all-project",
    search: "",
    project_language_data: [
      { name: "English", id: "English" },
      { name: "Bangla", id: "Bangla" },
      { name: "English & Bangla both", id: "English & Bangla both" },
    ],
    date: null,
    searchItem: {
      keyword: "",
      project_id: "",
    },
    editedIndex: -1,
    defaultItem: {
      keyword: "",
      project_id: "",
    },
    submitData: {
      data: [],
    },
    valid: true,
    keyword: [(v) => !!v || "This field is required."],
    projects: [(v) => !!v || "This field is required."],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isProjectSelected() {
      if (this.searchItem.project_id == "") {
        return true;
      } else {
        return false;
      }
    },

    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {
    //
  },

  created() {
    this.initialize();
    // this.editedData()
  },
  methods: {
    initialize() {
      if(!this.isLoggedIn){
        router.push('/signin');
      }
      // console.log(this.$route.params.id);
      // this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (!/^[A-Za-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    getDataForView: function (passData, coldata) {
      // console.log(passData);
      const arrayFailed = Object.entries(passData).map((arr) => ({
        key: arr[0],
        value: arr[1],
      }));
      // console.log(arrayFailed);
      var mayData = "";
      arrayFailed.filter(function (elem) {
        if (elem.key == coldata) {
          mayData = elem.value;
        }
      });
      // console.log(coldata);
      return mayData;
    },
    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    getColumns() {
      var columnsData = [
        { text: "Task ID", align: "center", value: "id" },
        { text: "Project Id", align: "center", value: "project_id" },
        { text: "Dasher Id", align: "center", value: "dasher_id" },
      ];
      if (this.indexData.projects_variables) {
        this.indexData.projects_variables.forEach((value) => {
          columnsData.push({
            text: value,
            align: "left",
            sortable: false,
            value: value,
          });
        });
      }
      // columnsData.push({ text: "Actions", align: "center", value: "actions" });
      return columnsData;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    submit() {
      // console.log(this.searchItem)
      if (this.$refs.form.validate()) {
        this.$store.dispatch("responseData", [
          "filter-response",
          this.$route.params.id,
          this.searchItem.keyword,
        ]);
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 100%;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
